import { PlaceholderPage } from '../../components/ui/PlaceholderPage.tsx'
import { IconSettings } from '@tabler/icons-react'
export function SettingsPage() {
  return <PlaceholderPage title="Settings" description="Manage your preferences and account settings" icon={<IconSettings size={22} className="text-zinc-600" />} />
}
